import React from "react";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import LoginForm from "../../Components/LoginModule/LoginModule";
import LoginBanner from "../../Components/LoginModule/LoginBanner";

const Login = () => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Grid container>
      <Grid item xs={12} md={6}>
        <LoginForm />
      </Grid>
      {isLargeScreen && (
        <Grid item md={6}>
          <LoginBanner />
        </Grid>
      )}
    </Grid>
  );
};

export default Login;
